import * as React from "react"

type OwnerLeadFormContextType = {
  isOpen: boolean
  open: () => void
  close: () => void
}

const OwnerLeadFormContext = React.createContext<
  OwnerLeadFormContextType | undefined
>(undefined)

export const OwnerLeadFormProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const open = React.useCallback(() => setIsOpen(true), [])
  const close = React.useCallback(() => setIsOpen(false), [])
  const value = React.useMemo(
    () => ({ isOpen, open, close }),
    [isOpen, open, close]
  )

  return (
    <OwnerLeadFormContext.Provider value={value}>
      {children}
    </OwnerLeadFormContext.Provider>
  )
}

export const useOwnerLeadForm = (): OwnerLeadFormContextType => {
  const ctx = React.useContext(OwnerLeadFormContext)
  if (!ctx) {
    throw new Error(
      "useOwnerLeadForm must be used within OwnerLeadFormProvider"
    )
  }
  return ctx
}
